import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// Roles that should be redirected to their portals instead of the internal app.
const PORTAL_ROUTE = {
  student_client: "/portal/student",
  franchise_partner: "/portal/franchise",
  external_partner: "/portal/franchise",   // same portal UI — shows partner tools + earnings
};

// Routes explicitly allowed for portal roles so they can access shared
// features (e.g. Earnings Calculator lives inside /finance/commissions).
const PORTAL_ALLOWED_PATHS = [
  "/finance/commissions",
  "/my-earnings",
  "/my-id",
  "/account/change-password",
];

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const redirectState = useMemo(() => ({ from: loc.pathname }), [loc.pathname]);

  if (!user) return <Navigate to="/login" replace state={redirectState} />;

  // Forced password change on first login / after admin reset.
  if (user.password_must_change && loc.pathname !== "/account/change-password") {
    return <Navigate to="/account/change-password" replace />;
  }

  const portal = PORTAL_ROUTE[user.role];
  const onAllowedPortalPath = PORTAL_ALLOWED_PATHS.some(
    p => loc.pathname.startsWith(p));
  if (portal && !loc.pathname.startsWith(portal) && !onAllowedPortalPath) {
    return <Navigate to={portal} replace />;
  }
  return children;
}
